// These functions are only used in selfguided mode.
// They are adding functionality to the control buttons in audios and video and starting entries in multistations
document.addEventListener('turbolinks:load', () => {
    const previewControlContainer = document.getElementById('previewControlContainer')
    const previewControlRestart = document.getElementById('previewControlRestart')
    const previewControlReplay10 = document.getElementById('previewControlReplay10')
    const previewPlayPauseButton = document.getElementById('previewPlayPauseButton')
    const previewControlForward10 = document.getElementById('previewControlForward10')
    const previewControlProgress = document.getElementById('previewControlProgress')
    const previewControlProgressDot = document.getElementById('previewControlProgressDot')
    const previewControlProgressTime = document.getElementById('previewControlProgressTime')
    const previewControlMaxTime = document.getElementById('previewControlMaxTime')

    //Only in multi stations
    const previewControlMultiStationClose = document.getElementById('previewControlMultiStationClose')
    const previewMultiStationMediaControl = document.getElementById('previewMultiStationMediaControl')
    const multiStationStartMedia = document.getElementsByClassName('multiStationStartMedia')
    const previewControlMultiStationUpper = document.getElementById('previewControlMultiStationUpper')
    const previewControlAudioThumbnail = document.getElementById('previewControlAudioThumbnail')
    const multiStationBottomPadding = document.getElementById('multiStationBottomPadding')
    const previewControlMediaName = document.getElementById('previewControlMediaName')
    const previewControlMediaNameVideoIcon = document.getElementById('previewControlMediaNameVideoIcon')
    const previewControlMediaNameAudioIcon = document.getElementById('previewControlMediaNameAudioIcon')
    const selfGuidedOpenFullscreen = document.getElementById('selfGuidedOpenFullscreen')
    const previewControlAudioTranscription = document.getElementById('previewControlAudioTranscription')

    const video = document.getElementsByTagName('video')[0]
    const audio = document.getElementsByTagName('audio')[0]
    let media

    let isMultiStation = false

    //For scrolling through progress bar with mouse clicked
    let mousedown = false

    if (previewControlContainer !== null && previewPlayPauseButton !== null && previewControlProgress !== null && previewControlProgressDot !== null &&
        previewControlRestart !== null && previewControlReplay10 !== null && previewControlForward10 !== null) {

        previewControlRestart.addEventListener('click', resetMedia)
        previewControlReplay10.addEventListener('click', handleSkip)
        previewPlayPauseButton.addEventListener('click', togglePlay)
        previewControlForward10.addEventListener('click', handleSkip)

        //If single station or a station is autostarted, the type is known
        if (previewControlContainer.dataset.media_type === "video"){
            media = video
        } else if (previewControlContainer.dataset.media_type === "audio"){
            media = audio
        }
        addMediaListeners()
        if (media.dataset.autoplay === "true"){
            media.play()
        }

        //.parent.parent for bigger Area where click activates the function
        previewControlProgress.parentElement.parentElement.addEventListener("mousedown", (e) => {mousedown = true; scrub(e)});
        previewControlProgress.parentElement.parentElement.addEventListener("mousemove", (e) => mousedown && scrub(e));
        document.addEventListener("mouseup", () => (mousedown = false)); //sets mousedown to false independent of mouse position

        // only for multi stations to change the button appearances of the playable media
        if (previewControlMultiStationClose !== null && previewMultiStationMediaControl !== null && previewControlMultiStationUpper !== null){ //multistation
            previewControlMultiStationClose.addEventListener('click', hideMediaContainer)
            isMultiStation = true
            if(video !== null){
                video.addEventListener("ended", ()=>setTimeout(handleAutoplay, 500))
                video.addEventListener("pause", pauseMultiButton)
                video.addEventListener("play", playMultiButton)
            }
            if(audio !== null){
                audio.addEventListener("ended", ()=>setTimeout(handleAutoplay, 500))
                audio.addEventListener("pause", pauseMultiButton)
                audio.addEventListener("play", playMultiButton)
            }
            for (let mediaStart of multiStationStartMedia){
                mediaStart.addEventListener('click', startMediaContainer)
            }
        }
    }

    function togglePlay() {
        if (media.paused || media.ended) {
            media.play()
        } else {
            media.pause()
        }
    }

    function updateToggleButton() {
        let playSvg = previewPlayPauseButton.getElementsByTagName('svg')[0]
        let pauseSvg = previewPlayPauseButton.getElementsByTagName('svg')[1]
        if (media.paused){
            playSvg.classList.remove('hidden')
            pauseSvg.classList.add('hidden')
        } else {
            playSvg.classList.add('hidden')
            pauseSvg.classList.remove('hidden')
        }
    }

    function handleProgress() {
        let portraitMode = true
        if (media.id === "selfGuidedStationPreviewLandscapeVideo"){
            portraitMode = false
        }
        // if duration is not available (after changing media), use duration = 100 as fallback, otherwise you get NaN
        // Sometimes the duration was Infinity, so take the media duration from dataset
        let progressPercentage = Math.round((media.currentTime / (parseFloat(media.dataset.media_duration) || 100)) * 100)
        // the dataset accuracy is in seconds and the current time in ms, so currentTime could be 999ms bigger than duration
        if (progressPercentage > 100){
            progressPercentage = 100
        }
        if (portraitMode) {
            //default progress bar is in portrait mode
            if (previewControlProgress.tagName === "DIV") {
                // progress as div that covers a percentage of parent
                previewControlProgress.style.width = `${progressPercentage}%`
            } else {
                // progress Tag
                previewControlProgress.value = progressPercentage
                previewControlProgress.innerHTML = `${progressPercentage}%`
            }
            previewControlProgressDot.style.left = `${progressPercentage}%`
        } else {
            // Landscape progress bar, different cause the screen is rotated
            if (previewControlProgress.tagName === "DIV") { //previewControlProgress.classList.contains('progressDiv')) {
                // progress as div that covers a percentage of parent
                previewControlProgress.style.height = `${progressPercentage}%`
            } else {
                // progress Tag
                previewControlProgress.value = progressPercentage
                previewControlProgress.innerHTML = `${progressPercentage}%`
            }
            previewControlProgressDot.style.top = `${progressPercentage}%`
        }

        previewControlProgressTime.innerHTML = secondsToMinuteString(media.currentTime)
    }

    //Takes the seconds and writes it in the format 'mm:ss'
    function secondsToMinuteString(seconds) {
        seconds = Math.floor(seconds)

        let minutes = Math.floor(seconds / 60)
        let remained_seconds = seconds % 60
        return `${minutes.toString().padStart(2, '0')}:${remained_seconds.toString().padStart(2, '0')}`
    }

    //sets the media to the time selected with the progress bar
    function scrub(event) {
        const rect = previewControlProgress.parentElement.getBoundingClientRect();
        const offsetX = event.pageX - rect.left - window.scrollX;
        const scrubTime = (offsetX / rect.width) * parseFloat(media.dataset.media_duration);

        media.currentTime = scrubTime;
    }

    //Set time to 0
    function resetMedia(){
        media.currentTime = 0
    }

    function mediaEnded(){
        setTimeout(resetMedia, 500)
    }

    //Skips to a diffrent point in media.
    //Skips the time in second defined in data-skip
    function handleSkip() {
        let newTime = media.currentTime + parseInt(this.dataset.skip)
        //the media time should be lower than the duration
        media.currentTime = Math.min(newTime, parseFloat(media.dataset.media_duration)-0.01)
    }

    function handleAutoplay(){
        //TODO: check if next media should be played otherwise hide container
        hideMediaContainer()
    }

    //What happens when you click the 'x' in the multistation media player or when media ended
    function hideMediaContainer() {
        previewMultiStationMediaControl.classList.add('hidden')
        media.pause()
        resetMedia()
        resetButtons()
        multiStationBottomPadding.classList.remove('pb-75p')
        multiStationBottomPadding.classList.remove('pb-130p')
        // TODO: delete or change to new value
        // multiStationBottomPadding.classList.add('pb-8.8p')
    }

    //Opens the multistation media player by clicking on a play button of a sme
    function startMediaContainer(event) {
        //Clicked button, take nearest button if target is svg or path
        let evtButton = (event.target.tagName !== "button" ? event.target.closest('button') : event.target)
        if (evtButton.dataset.media_status === "playing"){
            //Pause media by clicking sme-button
            media.pause()
            evtButton.dataset.media_status = "paused"
            let targetSvgs = evtButton.getElementsByTagName('svg')
            targetSvgs[0].classList.remove('hidden')
            targetSvgs[1].classList.add('hidden')
            return //Current media, no need to reload media_control
        } else if (evtButton.dataset.media_status === "paused") {
            //Resume media by clicking sme-button
            media.play()
            evtButton.dataset.media_status = "playing"
            let targetSvgs = evtButton.getElementsByTagName('svg')
            targetSvgs[0].classList.add('hidden')
            targetSvgs[1].classList.remove('hidden')
            return //Current media, no need to reload media_control
        }
        //From here the played media will change
        media.pause()
        //remove media listeners, cause the next media could have another type
        removeMediaListeners()

        previewControlMediaName.innerHTML = evtButton.dataset.media_name
        if (evtButton.dataset.media_type === "video"){
            previewControlMediaNameVideoIcon.classList.remove('hidden')
            previewControlMediaNameAudioIcon.classList.add('hidden')
            // Change View to preview image and video station and ensure big media_control
            video.src = evtButton.dataset.media_src
            video.dataset.media_duration = evtButton.dataset.media_duration
            media = video
            previewMultiStationMediaControl.dataset.media_type = "video"

            audio.parentElement.classList.add('hidden')
            video.parentElement.classList.remove('hidden')

            previewControlMultiStationUpper.classList.remove('h-13p')
            previewControlMultiStationUpper.classList.add('h-40p')

            multiStationBottomPadding.classList.remove('pb-75p')
            multiStationBottomPadding.classList.add('pb-130p')
            // TODO: delete or change to new value
            // multiStationBottomPadding.classList.remove('pb-8.8p')
            if (selfGuidedOpenFullscreen !== null){
                // change full_screen link to current sme
                let currentLink = selfGuidedOpenFullscreen.href
                let pathArray = currentLink.split('/')
                pathArray[pathArray.length - 1] = evtButton.dataset.sme_id
                selfGuidedOpenFullscreen.href = pathArray.join('/')
                selfGuidedOpenFullscreen.click()
                return //other screen is loaded, so end function here
            }
        } else if (evtButton.dataset.media_type === "audio"){
            previewControlMediaNameVideoIcon.classList.add('hidden')
            previewControlMediaNameAudioIcon.classList.remove('hidden')
            // Change View to audio with thumbnail image or smaller view without image
            audio.src = evtButton.dataset.media_src
            audio.dataset.media_duration = evtButton.dataset.media_duration
            media = audio
            previewMultiStationMediaControl.dataset.media_type = "audio"

            video.parentElement.classList.add('hidden')
            audio.parentElement.classList.remove('hidden')

            if (evtButton.dataset.audio_thumb === "null" && evtButton.dataset.transcription === "") {
                previewControlMultiStationUpper.classList.remove('h-40p')
                previewControlMultiStationUpper.classList.add('h-13p')
                // Hide Thumbnail and Transcription
                previewControlAudioThumbnail.src = ""
                previewControlAudioThumbnail.classList.add('hidden')
                previewControlAudioTranscription.innerHTML = ""
                previewControlAudioTranscription.classList.add('hidden')

                multiStationBottomPadding.classList.add('pb-75p')
                multiStationBottomPadding.classList.remove('pb-130p')
                // TODO: delete or change to new value
                // multiStationBottomPadding.classList.remove('pb-8.8p')

            } else if (evtButton.dataset.transcription !== ""){
                // Hide Thumbnail
                previewControlAudioThumbnail.src = ""
                previewControlAudioThumbnail.classList.add('hidden')
                // Show Transcription
                previewControlAudioTranscription.classList.remove('hidden')
                previewControlAudioTranscription.innerHTML = evtButton.dataset.transcription

                previewControlMultiStationUpper.classList.remove('h-13p')
                previewControlMultiStationUpper.classList.add('h-40p')

                multiStationBottomPadding.classList.remove('pb-75p')
                multiStationBottomPadding.classList.add('pb-130p')
            } else {
                // Hide Transcription
                previewControlAudioTranscription.classList.add('hidden')
                previewControlAudioTranscription.innerHTML = ""
                //Show Thumbnail
                previewControlAudioThumbnail.src = evtButton.dataset.audio_thumb
                previewControlAudioThumbnail.classList.remove('hidden')

                previewControlMultiStationUpper.classList.remove('h-13p')
                previewControlMultiStationUpper.classList.add('h-40p')

                multiStationBottomPadding.classList.remove('pb-75p')
                multiStationBottomPadding.classList.add('pb-130p')
                // TODO: delete or change to new value
                // multiStationBottomPadding.classList.remove('pb-8.8p')
            }
        }
        //Change all buttons to play symbol
        for (let mediaStart of multiStationStartMedia){
            let buttonSvgs = mediaStart.getElementsByTagName('svg')
            buttonSvgs[0].classList.remove('hidden')
            buttonSvgs[1].classList.add('hidden')
            mediaStart.dataset.media_status = "not loaded"
        }
        //Change pressed button to pause symbol
        let targetSvgs = evtButton.getElementsByTagName('svg')
        targetSvgs[0].classList.add('hidden')
        targetSvgs[1].classList.remove('hidden')

        //load new media and play content
        previewMultiStationMediaControl.classList.remove('hidden')
        media.load()
        // take duration saved in the button. media.duration is still NaN immediately after loading
        previewControlMaxTime.innerHTML = secondsToMinuteString(evtButton.dataset.media_duration)
        evtButton.dataset.media_status = "playing"
        addMediaListeners()
        media.play()
    }

    //Change all sme-Buttons to the play symbol
    function resetButtons(){
        //Change all buttons to play symbol
        for (let mediaStart of multiStationStartMedia){
            let buttonSvgs = mediaStart.getElementsByTagName('svg')
            buttonSvgs[0].classList.remove('hidden')
            buttonSvgs[1].classList.add('hidden')
            mediaStart.dataset.media_status = "not loaded"
        }
    }

    //Change the sme-Buttons of current media to the play symbol
    function pauseMultiButton(){
        for (let mediaStart of multiStationStartMedia){
            let buttonSvgs = mediaStart.getElementsByTagName('svg')
            if (mediaStart.dataset.media_status === "playing") {
                mediaStart.dataset.media_status = "paused"
                buttonSvgs[0].classList.remove('hidden')
                buttonSvgs[1].classList.add('hidden')
            }
        }
    }

    //Change the sme-Buttons of current media to the pause symbol
    function playMultiButton(){
        for (let mediaStart of multiStationStartMedia){
            let buttonSvgs = mediaStart.getElementsByTagName('svg')
            if (mediaStart.dataset.media_status === "paused") {
                mediaStart.dataset.media_status = "playing"
                buttonSvgs[0].classList.add('hidden')
                buttonSvgs[1].classList.remove('hidden')
            }
        }
    }

    //adds event-listeners to media
    function addMediaListeners(){
        media.addEventListener("play", updateToggleButton)
        media.addEventListener("pause", updateToggleButton)
        media.addEventListener("timeupdate", handleProgress)
        media.addEventListener("ended", mediaEnded)
    }

    //remove event-listeners from media
    function removeMediaListeners(){
        media.removeEventListener("play", updateToggleButton)
        media.removeEventListener("pause", updateToggleButton)
        media.removeEventListener("timeupdate", handleProgress)
        media.removeEventListener("ended", mediaEnded)
    }

})